import glo from '../../main'
import { tkParse } from '@moke/vue-tk'

export default {
  className: 'residentialQuarters',
  render: (residentialQuarters) => {
    return `${residentialQuarters.name}`
  },
  fields: [
    {
      name: 'name',
      validators: [
        (val) => val ? null : '小区不可为空'
      ]
    },
    {
      name: 'business'
    }
  ],
  hooks: {
    async beforeInsert ({ data }) {
      const { data: res } = await tkParse.get(`/classes/residentialQuarters`, {
        params: {
          where: {
            name: data.name
          }
        }
      })
      if (res.results.length) {
        throw new Error('小区已存在')
      }
    }
  },
  action: {
    // delete: false,
    download: {
      type: 'list',
      text: '下载模板',
      callback: async function () {
        window.open('https://moke-runji.oss-cn-beijing.aliyuncs.com/c653a9da-d662-4b7c-90de-33c9fcd2e474.xlsx', '_blank')
      }
    },
    imports: {
      type: 'list',
      icon: 'import',
      text: '导入',
      callback: async function imports ({ vm }) {
        try {
          const excel = await glo.$excel.pick()
          const exceldata = excel.toJson()
          glo.$loading.show()
          for (let i = 0; i < exceldata.Sheet1.length; i++) {
            const element = exceldata.Sheet1[i]
            // 获取对象的key
            const keys = Object.keys(element)
            // 判断两个数组元素是否相同
            const board = ['小区名称']
            const isSame = keys.every((item) => board.includes(item))
            if (!isSame) {
              throw new Error()
            }
            const data = element['小区名称'].toString()
            const res = await tkParse.get(`/classes/residentialQuarters`, {
              params: {
                where: {
                  name: data
                }
              }
            })
            if (res.data.results.length === 0) {
              await tkParse.post(`/classes/residentialQuarters`, {
                name: data
              })
            }
          }
          glo.$loading.hide()
          glo.$notification['success']({
            message: '操作成功',
            description: '数据已导入'
          })
          vm.refresh()
        } catch (e) {
          glo.$loading.hide()
          glo.$notification['error']({
            message: '操作失败',
            description: '数据格式错误'
          })
        }
      }
    }
  }
}
